import { Navigate, Outlet } from "react-router-dom";

function Auth({ user, location }) {
  const hasSession =
    sessionStorage.getItem("_t") || localStorage.getItem("_t");

  if (user && hasSession && !location?.state?.gotoJobBoard) {
    return (
      <Navigate
        to={user.phoneNumber ? "/dashboard" : "/my-profile"}
        replace
      />
    );
  }

  return <Outlet />;
}
export default Auth;
